import {LeaderboardUser} from '@dms/api/settings';

/** Client-side search by user label (case-insensitive). */
export const filterLeaderboardUsers = (
  users: LeaderboardUser[],
  search: string
): LeaderboardUser[] => {
  const normalizedSearch = search.trim().toLowerCase();

  return normalizedSearch.length === 0
    ? users
    : users.filter((user) => user.label.toLowerCase().includes(normalizedSearch));
};
